import { incrementWithCycle } from "common/functions/utilities";
import { City } from "common/interfaces/City";
import { EstateFilterConditions } from "common/interfaces/EstateFilterConditions";
import { Prefecture } from "common/interfaces/Prefecture";
import { useCallback } from "react";
import { removeLayer, unshiftLayer } from "../functions/layers";
import { SearchBehaviorStatesType } from "../states/behaviors";
import { SearchDialogStatesType } from "../states/dialogs";
import { SearchFilterConditionStatesType } from "../states/filterConditions";
import { SearchMapStatesType } from "../states/maps";

export const useSearchDefaultConditionInputDialogHandlers = (
  mapStates: SearchMapStatesType,
  behaviorStates: SearchBehaviorStatesType,
  dialogStates: SearchDialogStatesType,
  filterConditionStates: SearchFilterConditionStatesType,
  onSwitchAreaDialogOkButtonClick: (
    selectedPrefectures: Prefecture[],
    selectedCities: City[]
  ) => void
) => {
  const onDefaultConditionInputDialogClose = useCallback(() => {
    dialogStates.setShowDefaultConditionInputDialog(false);
    dialogStates.setDefaultConditionInputDialogSign(incrementWithCycle);
  }, [dialogStates]);

  const onDefaultConditionInputDialogMouseDown = useCallback(() => {
    dialogStates.setDefaultConditionInputDialogSign(incrementWithCycle);
  }, [dialogStates]);

  const onDefaultConditionInputDialogSignChange = useCallback(
    (show: boolean) => {
      if (show) {
        dialogStates.setLayers((x) => unshiftLayer(x, "defaultConditionInput"));
      } else {
        dialogStates.setLayers((x) => removeLayer(x, "defaultConditionInput"));
      }
    },
    [dialogStates]
  );

  const onOkButtonClick = useCallback(
    (result: {
      selectedPrefectures?: Prefecture[];
      selectedCities?: City[];
      filterConditions?: EstateFilterConditions;
      areaChanged: boolean;
      priceLabel: boolean;
      tsuboLabel: boolean;
    }) => {
      if (result.filterConditions) {
        filterConditionStates.forceFilterConditions(result.filterConditions);
      }

      if (result.areaChanged) {
        onSwitchAreaDialogOkButtonClick(
          result.selectedPrefectures || [],
          result.selectedCities || []
        );
      }

      mapStates.setDspPrice(result.priceLabel);
      mapStates.setDspTsuboArea(result.tsuboLabel);

      behaviorStates.setOpenMenu(false);
    },
    [
      behaviorStates,
      filterConditionStates,
      mapStates,
      onSwitchAreaDialogOkButtonClick
    ]
  );

  return {
    onDefaultConditionInputDialogClose,
    onDefaultConditionInputDialogMouseDown,
    onDefaultConditionInputDialogSignChange,

    onOkButtonClick
  } as const;
};

export type SearchDefaultConditionInputDialogHandlersType = ReturnType<
  typeof useSearchDefaultConditionInputDialogHandlers
>;
